<div class="filter_phater_flex">
  <div class="filter_phater">
    <div
      class="__filters"
      #filters
      (mouseover)="inover()"
      (mouseout)="showbutton = false"
      [@scrollAnimation]
    >
      <ng-content *ngIf="showfilter" [@inOutfilter]> </ng-content>
    </div>
    <div
      class="jc-right"
      *ngIf="showfilter && showright"
      (mouseover)="inover()"
    >
      <button
        class="__button_row_scroll"
        mat-icon-button
        (click)="scroll()"
        *ngIf="showfilter && showright && showbutton"
        (mouseover)="inover()"
        [@inOutbuttons]
      >
        <mat-icon class="text-disabled">chevron_right</mat-icon>
      </button>
    </div>

    <div
      class="jc-left"
      *ngIf="showfilter && showleft"
      (mouseover)="showbutton = true"
    >
      <button
        class="__button_row_scroll"
        *ngIf="showfilter && showleft && showbutton"
        mat-icon-button
        (click)="scroll(false)"
        (mouseover)="inover()"
        [@inOutbuttons]
      >
        <mat-icon class="text-disabled">chevron_left</mat-icon>
      </button>
    </div>
  </div>
</div>
